import _classCallCheck from "/opt/noser/hris/uat1/producthris/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/noser/hris/uat1/producthris/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/opt/noser/hris/uat1/producthris/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/noser/hris/uat1/producthris/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/opt/noser/hris/uat1/producthris/node_modules/@babel/runtime/helpers/esm/inherits";

/**
 * DevExtreme (esm/renovation/ui/pager/info.js)
 * Version: 21.1.12
 * Build date: Fri Apr 07 2023
 *
 * Copyright (c) 2012 - 2023 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _excluded = ["defaultPageIndex", "infoText", "pageCount", "pageIndex", "pageIndexChange", "rootElementRef", "totalCount"];
import { createVNode } from "inferno";
import { BaseInfernoComponent } from "@devextreme/vdom";
import { format } from "../../../core/utils/string";
import messageLocalization from "../../../localization/message";
import { PagerProps } from "./common/pager_props";
export var PAGER_INFO_CLASS = "dx-info";
export var viewFunction = function viewFunction(_ref) {
  var rootElementRef = _ref.props.rootElementRef,
      text = _ref.text;
  return createVNode(1, "div", PAGER_INFO_CLASS, text, 0, null, null, rootElementRef);
};
export var InfoTextProps = {};
var InfoTextPropsType = {
  pageCount: PagerProps.pageCount,
  totalCount: PagerProps.totalCount,
  defaultPageIndex: PagerProps.pageIndex,
  pageIndexChange: function pageIndexChange() {}
};
export var InfoText =
/*#__PURE__*/
function (_BaseInfernoComponent) {
  _inherits(InfoText, _BaseInfernoComponent);

  function InfoText(props) {
    var _this;

    _classCallCheck(this, InfoText);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(InfoText).call(this, props));
    _this._currentState = null;
    _this.state = {
      pageIndex: void 0 !== _this.props.pageIndex ? _this.props.pageIndex : _this.props.defaultPageIndex
    };
    return _this;
  }

  _createClass(InfoText, [{
    key: "set_pageIndex",
    value: function set_pageIndex(value) {
      var _this2 = this;

      this.setState(function (state) {
        _this2._currentState = state;
        var newValue = value();

        _this2.props.pageIndexChange(newValue);

        _this2._currentState = null;
        return {
          pageIndex: newValue
        };
      });
    }
  }, {
    key: "render",
    value: function render() {
      var props = this.props;
      return viewFunction({
        props: _extends({}, props, {
          pageIndex: this.__state_pageIndex
        }),
        infoText: this.infoText,
        text: this.text,
        restAttributes: this.restAttributes
      });
    }
  }, {
    key: "__state_pageIndex",
    get: function get() {
      var state = this._currentState || this.state;
      return void 0 !== this.props.pageIndex ? this.props.pageIndex : state.pageIndex;
    }
  }, {
    key: "infoText",
    get: function get() {
      return this.props.infoText || messageLocalization.getFormatter("dxPager-infoText")();
    }
  }, {
    key: "text",
    get: function get() {
      var _this$props = this.props,
          pageCount = _this$props.pageCount,
          totalCount = _this$props.totalCount;
      return format(this.infoText, (this.__state_pageIndex + 1).toString(), pageCount.toString(), totalCount.toString());
    }
  }, {
    key: "restAttributes",
    get: function get() {
      var _this$props$pageIndex = _extends({}, this.props, {
        pageIndex: this.__state_pageIndex
      }),
          restProps = _objectWithoutPropertiesLoose(_this$props$pageIndex, _excluded);

      return restProps;
    }
  }]);

  return InfoText;
}(BaseInfernoComponent);
InfoText.defaultProps = _extends({}, InfoTextPropsType);